import base from "./base/index"; // 接口域名列表
import axios from "../utils/http"; // 导入http中创建的axios实例
import utils from "../utils";
/**
 * 经销商
 */
const dealer = {

  /**
   * 新增经销商
   */
  addDealer (name, address, tel) {
    return axios.post(base.dealer.addDealer, utils.postParamsArrayToJsonString({ name, address, tel }))
  },
  /**
   * 修改经销商
   */
  modifyDealer (id, name, address, tel) {
    return axios.post(base.dealer.modifyDealer, utils.postParamsArrayToJsonString({ id, name, address, tel }))
  },
  /**
   * 查询经销商
   */
  getDealer (id) {
    return axios.post(base.dealer.getDealer, utils.postParamsArrayToJsonString({ id }))
  },
  /**
   * 查询经销商
   */
  getDealer2 (name) {
    return axios.post(base.dealer.getDealer2, utils.postParamsArrayToJsonString({ name }))
  },
  /**
   * 删除经销商
   */
  deleteDealer (id) {
    return axios.post(base.dealer.deleteDealer, utils.postParamsArrayToJsonString({ id }))
  },
  /**
   * 新增销售人员
   */
  addSalesperson (dealerId, name, tel) {
    return axios.post(base.dealer.addSalesperson, utils.postParamsArrayToJsonString({ dealerId, name, tel }))
  },
  /**
   * 修改销售人员
   */
  modifySalesperson (salespersonId, name, tel) {
    return axios.post(base.dealer.modifySalesperson, utils.postParamsArrayToJsonString({ salespersonId, name, tel }))
  },
  /**
   * 查询销售人员
   */
  getSalesperson (salespersonId) {
    return axios.post(base.dealer.getSalesperson, utils.postParamsArrayToJsonString({ salespersonId }))
  },
  /**
   * 查询销售人员
   */
  getSalesperson2 (dealerId, name) {
    return axios.post(base.dealer.getSalesperson2, utils.postParamsArrayToJsonString({ dealerId, name }))
  },
  /**
   * 删除销售人员
   */
  deleteSalesperson (salespersonId) {
    return axios.post(base.dealer.deleteSalesperson, utils.postParamsArrayToJsonString({ salespersonId }))
  },
}

export default dealer